import { z } from 'zod';

export type SwitchTenantPayload = z.infer<typeof switchTenantPayloadSchema>;

export const switchTenantPayloadSchema = z.object({
  tenantId: z.uuid(),
});
